var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { injectable } from 'inversify';
import { BaseManagementService } from '@/services/base-management-service';
var UpMarketLoadConfigService = /** @class */ (function (_super) {
    __extends(UpMarketLoadConfigService, _super);
    function UpMarketLoadConfigService() {
        return _super.call(this, "/api/v1/opportunity") || this;
    }
    UpMarketLoadConfigService.prototype.getDefault = function () {
        return {
            oppUpVoyId: '',
            siteId: '',
            siteName: '',
            materialId: '',
            materialDesc: '',
            loadSize: 0,
            timeWindowStart: '',
            timeWindowEnd: '',
            sourceType: '',
            vendorId: '',
            vendorName: '',
            carrierId: '',
            carrierName: '',
        };
    };
    UpMarketLoadConfigService.prototype.getValidationRules = function () {
        return {
            site: {
                required: true,
            },
            material: {
                required: true,
            },
            loadSize: {
                required: true,
                min_value: 1,
                max_value: 20000,
                max: 5,
            },
            fromTimeWindow: {
                required: true,
            },
            toTimeWindow: {
                required: true,
            },
            sourceType: {
                required: true,
            },
            vendor: {
                required: true,
            },
            carrier: {
                required: true,
            },
        };
    };
    UpMarketLoadConfigService.prototype.validTimeWindow = function (to, from) {
        if (to > from) {
            return true;
        }
        return false;
    };
    UpMarketLoadConfigService.prototype.getAll = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.getFiltered('')];
            });
        });
    };
    UpMarketLoadConfigService.prototype.getFiltered = function (site) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/getupmarketloadconfigs';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                Site: site,
                            })];
                    case 2:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error("Unable to get opportunity up market load configurations");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Unable to get opportunity up market load configurations");
                        console.error(error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UpMarketLoadConfigService.prototype.canRestoreItem = function (item) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve(true)];
            });
        });
    };
    UpMarketLoadConfigService.prototype.canDeleteItem = function (item) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve(true)];
            });
        });
    };
    UpMarketLoadConfigService.prototype.createUpMarketLoadConfig = function (opportunityUpMarketLoadConfig) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, data, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/createupmarketloadconfig';
                        data = __assign({}, opportunityUpMarketLoadConfig);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                SiteId: data.siteId,
                                MaterialId: data.materialId,
                                LoadSize: data.loadSize,
                                TimeWindowStart: data.timeWindowStart,
                                TimeWindowEnd: data.timeWindowEnd,
                                SourceType: data.sourceType,
                                VendorId: data.vendorId,
                                CarrierId: data.carrierId,
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error('Unable to save up market load config');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.error('Unable to save up market load config');
                        console.error(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UpMarketLoadConfigService.prototype.updateUpMarketLoadConfig = function (opportunityUpMarketLoadConfig) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, data, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/updateupmarketloadconfig';
                        data = __assign({}, opportunityUpMarketLoadConfig);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                OppUpVoyId: data.oppUpVoyId,
                                SiteId: data.siteId,
                                MaterialId: data.materialId,
                                LoadSize: data.loadSize,
                                TimeWindowStart: data.timeWindowStart,
                                TimeWindowEnd: data.timeWindowEnd,
                                SourceType: data.sourceType,
                                VendorId: data.vendorId,
                                CarrierId: data.carrierId,
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error('Unable to save up market load config');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.error('Unable to save up market load config');
                        console.error(error_3);
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UpMarketLoadConfigService.prototype.delete = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = '/deleteupmarketloadconfig';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { OppUpVoyId: id })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        console.error("Unable to up market load config");
                        console.error(error_4);
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(UpMarketLoadConfigService.prototype, "canViewOpportunityActions", {
        get: function () {
            return this.canViewPage('OPPORTUNITYACTIONS');
        },
        enumerable: false,
        configurable: true
    });
    UpMarketLoadConfigService = __decorate([
        injectable(),
        __metadata("design:paramtypes", [])
    ], UpMarketLoadConfigService);
    return UpMarketLoadConfigService;
}(BaseManagementService));
export { UpMarketLoadConfigService };
